import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import CommonIcons from '../../icons/Common';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

const MoneyBackGuarantee = ({ membershipListData }) => {
	const { t } = useTranslation('common');

	return (
		<Box
			sx={{
				display: 'flex',
				alignItems: 'flex-start',
				gap: 1.5,
				mt: 2
			}}
		>
			<Box
				sx={{
					width: 32,
					height: 32,
					borderRadius: '50%',
					backgroundColor: 'background.default',
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
					flexShrink: 0
				}}
			>
				<CommonIcons.shield sx={{ fontSize: 24, color: 'text.secondary' }} />
			</Box>
			<Typography
				variant='caption'
				sx={{ color: 'text.secondary', lineHeight: 1.4 }}
			>
				<strong>
					{t('guaranteeTitle', { membership: membershipListData?.name })}
				</strong>{' '}
				{t('guaranteeText', {
					membership: membershipListData?.name,
					email: membershipListData?.contactEmail || 'support@sempris.com'
				})}
			</Typography>
		</Box>
	);
};

MoneyBackGuarantee.propTypes = {
	membershipListData: PropTypes.object
};

export default MoneyBackGuarantee;
